// extracted by mini-css-extract-plugin
module.exports = {"menuPaper":"styles_menuPaper__15A3v","menuList":"styles_menuList__32W6m","item":"styles_item__1IyPK","itemSelected":"styles_itemSelected__3Ah8t"};